import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface BootArgusInstanceInput {
  instanceId: string;
}

export function useBootArgusInstance() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: BootArgusInstanceInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}/boot`, {
        method: "POST",
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/instances"),
      });
      queryClient.invalidateQueries({
        queryKey: [`/client/argus/instances/${variables.instanceId}`],
      });
    },
  });
}
